import { createAsyncAction, createAction } from 'redux-promise-middleware-actions';
import * as engagementService from 'Api/Engagement/engagementService';

export const toggleIpdCard = createAction('TOGGLE_IPD_CARD', (isCollapsed) => ({ isCollapsed }));
export const getEngagementData = createAsyncAction('GET_ENGAGEMENT_DATA', engagementService.getEngagementInfo);
export const updateEngagementData = createAsyncAction('UPDATE_ENGAGEMENT_DATA', engagementService.updateEngagementInfo);
